<div [formGroup]="form">
    <h4 class="pt-2">{{ translate.getLng("TRAPEZ_SHEET_MATERIAL") }}</h4>
    <div fxLayout="row">
        <mat-radio-group
            class="d-block"
            (change)="fetchInput($event)"
            formControlName="material"
        >
            <mat-radio-button
                *ngFor="let m of rbMaterial"
                [value]="m.data"
                class="mr-2"
            >
                {{ m.label }}</mat-radio-button
            >
        </mat-radio-group>
    </div>
    <hr class="border-white" />
    <h4 class="pt-2">{{ translate.getLng("TRAPEZ_SHEET_THICKNESS") }}</h4>
    <div fxLayout="row" class="w-50">
        <input
            class="mx-2 border-bottom border-dark text-right"
            step="0.01"
            type="number"
            formControlName="thickness"
            matInput
        />
        <span class="sen-fs10">{{ translate.getLng("UNIT_MM") }}</span>
        <mat-icon
            class="sen-cursor-pointer"
            matTooltipClass="sen-snackbar-color"
            matTooltip="{{ translate.getLng('HINT_INPUT_DECIMAL') }}"
            >info</mat-icon
        >
    </div>
    <hr class="border-white" />
    <h4 class="pt-2">{{ translate.getLng("HIGH_BEADING_DISTANCE") }}</h4>
    <div fxLayout="row" class="w-50">
        <input
            formControlName="distance"
            class="text-right mx-2 border-bottom border-dark"
            min="{{ nMinHighBeadingDistance }}"
            max="{{ nMaxHighBeadingDistance }}"
            step="0.1"
            type="number"
            matInput
        />
        <span class="sen-fs10">{{ translate.getLng("UNIT_CM") }}</span>
        <mat-icon
            class="sen-cursor-pointer"
            matTooltipClass="sen-snackbar-color"
            matTooltip="{{ translate.getLng('HINT_INPUT_DECIMAL') }}"
            >info</mat-icon
        >
    </div>
    <mat-error class="sen-fs10 my-3" *ngIf="form.get('thickness')!.invalid">
        {{ translate.getLng("ERROR_TRAPEZ_SHEET_THICKNESS") }}<br />
        {{ translate.getLng("INPUT_MINIMUM") }}: {{ selectedrbMaterial.min
        }}<br />
        {{ translate.getLng("INPUT_MAXIMUM") }}: {{ selectedrbMaterial.max
        }}<br />
        {{ translate.getLng("YOUR_INPUT") }}: {{ form.get("thickness")!.value
        }}<br />
        {{ translate.getLng("HINT") }}:
        {{ translate.getLng("HINT_INPUT_DECIMAL") }}
    </mat-error>
    <mat-error class="sen-fs10 mt-3" *ngIf="form.get('distance')!.invalid">
        {{ translate.getLng("ERROR_TRAPEZ_HIGH_BEADING_DISTANCE") }}<br />
        {{ translate.getLng("INPUT_MINIMUM") }}: {{ nMinHighBeadingDistance
        }}<br />
        {{ translate.getLng("INPUT_MAXIMUM") }}: {{ nMaxHighBeadingDistance
        }}<br />
        {{ translate.getLng("YOUR_INPUT") }}: {{ form.get("distance")!.value
        }}<br />
        {{ translate.getLng("HINT") }}:
        {{ translate.getLng("HINT_INPUT_DECIMAL") }}
    </mat-error>
</div>
